import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from "../../../SpecialtyPersonalStyles.module.scss";
import metadata from './SolidFuelHeatingComponent.metadata.json5';

function SolidFuelHeatingComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, dwellingPathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('SolidFuelHeatingComponent');

    const modelVM = _.get(submissionVM, pathUpdated);
    const dwellingVM = _.get(submissionVM, dwellingPathUpdated);

    modelVM.value.isValidationReq = true;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        solidFuelHeatingContainer: {
            visible: !_.isUndefined(_.get(dwellingVM.value, 'construction.isthestoFie')) && _.get(dwellingVM.value, 'construction.isthestoFie')
        },
        whakinofsoudoyouusiasFie: {
            defaultValue: "Priheasou"
        },
        typofStoFie: {
            defaultValue: "OrdSto"
        },
        istheatlea18incclematFie: {
            defaultValue: true
        },
        isthefloshiextatlesidFie: {
            defaultValue: true
        },
        thefloconsupthestooisFie: {
            defaultValue: "Cononl"
        },
        ifOthDesFie: {
            visible: _.get(dwellingVM.value, 'construction.isthestoFie')
                && !_.isUndefined(_.get(modelVM.value, 'thefloconsupthestooisFie')) && _.get(modelVM.value, 'thefloconsupthestooisFie') === "Other"
        },
        wasappinsbyFie: {
            defaultValue: "Quains"
        },
        hastheheaappbeeinsappFie: {
            defaultValue: true
        },
        ifnopleprodetFie: {
            visible: _.get(dwellingVM.value, 'construction.isthestoFie')
                && !_.isUndefined( _.get(modelVM.value, 'hastheheaappbeeinsappFie')) && _.get(modelVM.value, 'hastheheaappbeeinsappFie') === false
        },

        chimneyContainer: {
            visible: _.get(dwellingVM.value, 'construction.isthechiFie')
        },
        istheChiFacbuiFie: {
            defaultValue: true
        },
        istheChiCusBuiFie: {
            defaultValue: false
        },
        istheChiproinsFie: {
            defaultValue: true
        },
        ifmetchiistheatleamatFie: {
            defaultValue: true
        },
        doetheappshachiwitappFie: {
            defaultValue: false
        },
        isthechiprocleannFie: {
            defaultValue: true
        },
        ifnohowoftFie: {
            visible: _.get(dwellingVM.value, 'construction.isthechiFie')
                && !_.isUndefined( _.get(modelVM.value, 'isthechiprocleannFie')) && _.get(modelVM.value, 'isthechiprocleannFie') === false
        },

        fireplaceContainer: {
            visible: _.get(dwellingVM.value, 'construction.isthefirFie')
        },
        ifFirInsOthpledesFie: {
            visible: _.get(dwellingVM.value, 'construction.isthefirFie')
                && !_.isUndefined( _.get(modelVM.value, 'firTypFie')) && _.get(modelVM.value, 'firTypFie') === "Other"
        },
        wasitinsproFie: {
            defaultValue: true
        },
        hastheheaappbeeinsoveFie: {
            defaultValue: true
        },
        ifnopleprodet2Fie: {
            visible: _.get(dwellingVM.value, 'construction.isthefirFie')
                && !_.isUndefined( _.get(modelVM.value, 'hastheheaappbeeinsoveFie')) && _.get(modelVM.value, 'hastheheaappbeeinsoveFie') === false
        },
        apphouappisuseFie: {
            defaultValue: 0
        },
        appnumofwoo2x4useaannFie: {
            defaultValue: 0
        },
        nooffirextFie: {
            defaultValue: 0
        },

        fluePipeContainer: {
            visible: _.get(dwellingVM.value, 'construction.istheflupipFie')
        },
        ifOthDes2Fie: {
            visible: _.get(dwellingVM.value, 'construction.istheflupipFie')
                && !_.isUndefined( _.get(modelVM.value, 'howoftarethepipcleFie')) && _.get(modelVM.value, 'howoftarethepipcleFie') === "Other"
        },
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

SolidFuelHeatingComponent.propTypes = wizardProps;
export default withRouter(SolidFuelHeatingComponent);